<template>
  <v-dialog
    content-class="ds-dialog"
    scrollable
    v-bind="$attrs"
    :value="value"
    :max-width="maxWidth"
    @v-on="$listeners"
  >
    <ds-card>
      <template v-slot:header>
        <slot name="header">
          <ds-card-title :icon="icon">
            {{ title }}
          </ds-card-title>
        </slot>
      </template>
      <slot />
      <template v-slot:footer>
        <slot name="footer">
          <ds-card-actions>
            <ds-button
              primary
              @click.stop.prevent="$emit('dismiss')"
            >
              {{ $t('message.common.accept') }}
            </ds-button>
          </ds-card-actions>
        </slot>
      </template>
    </ds-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DsDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    maxWidth: {
      type: [Number, String],
      default: 800,
    },
  },
};
</script>

<style lang="stylus">
@import "../../assets/stylus/variables.styl";

.ds-dialog {
  width: auto;
}
</style>
